import { callApi } from '../services/api';

const downloadFile = (path) => {
  return callApi.get(`/downloads/${path}`, {
    responseType: 'blob',
  });
};

export { downloadFile };
